import React, { Component } from 'react';
import { Link, Route, Switch, withRouter, matchPath } from 'react-router-dom';
import styled from 'styled-components';
import FontAwesomeIcon from 'components/FontAwesomeIcon';
import WorkInfo from 'components/WorkPage/WorkInfo';
import NoteList from 'components/WorkPage/NoteList';
import NoteView from 'components/WorkPage/NoteView';
import Divider from 'components/Divider';
import { translate } from 'util/Translator';
import { buildWorkPath } from 'util/workRoute';

const Container = styled.div`
  background: #fff;
  position: relative;
  overflow: auto;
  width: 495px;
  padding: 80px 30px 30px 30px;
  box-sizing: border-box;
  height: calc(100vh - 100px);
`;

const NavigationContainer = styled.div`
  margin-bottom: 30px;
`;

const NavigationBackLink = styled(Link)`
  color: #5863f8;
`;

const NavigationBackLabel = styled.div`
  margin-left: 10px;
  font-weight: bold;
`;

const NavigationDivider = styled(Divider)`
  margin-top: 10px;
`;

class WorkDetailDesktop extends Component {
  scrollToTop = () => {
    if (this.container) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
      this.container.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  };

  render() {
    const { t, work, staticContext, location } = this.props;
    const isMatchWorkRoute = matchPath(location.pathname, {
      path: '/works/:owner_screen_name/:signed_ref',
      exact: true,
      strict: false,
    });
    return (
      <Container ref={ref => (this.container = ref)}>
        {!isMatchWorkRoute && (
          <NavigationContainer>
            <NavigationBackLink
              to={buildWorkPath(work.data)}
            >
              <FontAwesomeIcon
                icon={['fas', 'chevron-left']}
                color="#5863F8"
                size={16}
              />
              <NavigationBackLabel>{t('back')}</NavigationBackLabel>
            </NavigationBackLink>
            <NavigationDivider />
          </NavigationContainer>
        )}
        <Switch>
          <Route
            path="/works/:owner_screen_name/:signed_ref"
            exact
            render={routeProps => (
              <WorkInfo
                work={work}
                onClickViewNote={this.scrollToTop}
                staticContext={staticContext}
                {...routeProps}
              />
            )}
          />
          <Route
            path="/works/:owner_screen_name/:signed_ref/notes/:note_id"
            exact
            render={routeProps => (
              <NoteView onClickViewNote={this.scrollToTop} {...routeProps} />
            )}
          />
          <Route
            path="/works/:owner_screen_name/:signed_ref/notes"
            exact
            render={routeProps => (
              <NoteList
                work={work.data}
                notes={work.notesList}
                onClickViewNote={this.scrollToTop}
                {...routeProps}
              />
            )}
          />
        </Switch>
      </Container>
    );
  }
}

export default withRouter(translate('workPage')(WorkDetailDesktop));
